export default __webpack_public_path__ + "0f99f7737d00a24cb9638b315e92ba2a.png";